import Modal from "../../../components/base/Modal";
import { toShortDateWithoutTime, useHub } from "../../../core/Global";
import { toastSuccess } from "../../../components/base/Toast";
import MigrationRow from "../models/MigrationRow";


// Rolling a move back, as if it never happened: the customer is on the old subscription again
// exactly as they were before -- same renewal date, add-ons and wallet settings -- and the plan
// is gone.
export default function RollbackModal(props: {
    row: MigrationRow,
    onClose: () => void,
    onDone: () => void
}) {

    const hub = useHub()
    const r = props.row
    const who = r.name ?? r.username

    return (
        <Modal id="modal-migration-rollback"
            title="Roll back migration"
            titleIcon="clock-rotate-left"
            open visible
            buttonText="Roll back"
            buttonColor="danger"
            onClose={props.onClose}
            onSubmit={(body, callback) => {
                hub.Post("/system/migration/rollback", { userId: r.userId }, res => {
                    callback!(res)
                    if (res.success) {
                        toastSuccess(`${who}'s migration was rolled back.`)
                        props.onDone()
                    }
                }, () => callback!({ success: false } as any))
            }}>
            <div className="fs-6">
                Roll back <b>{who}</b>'s move to <b>{r.planName}</b>
                {r.movedAt && <> on {toShortDateWithoutTime(new Date(r.movedAt))}</>}?
                <div className="text-gray-600 mt-3">
                    Everything goes back to exactly how it was before the move, as if it never happened.
                </div>
            </div>
        </Modal>
    )
}
